import MediaPreviewModal from "./MediaPreviewModal";

export default MediaPreviewModal;